/* eslint-disable */
/* eslint-disable prefer-template */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { setVehiclesSort } from '../actions';
import { selectVehicleFilter, selectFilterSingleValue, selectFilterValues, selectMMT } from '../selectors';
import { Dropdown } from '../../../components/Dropdown';
import { FormField } from '../../../components/FormFields';
import { companySearch } from '../../Companies/actions';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import styles from './VehicleSortSelector.module.css';

const STATE = {
  selected: null,
};

let VEHICLES_SORT_OPTIONS = [
  'createdAt_asc',
  'createdAt_desc',

  'task_label_asc',
  'task_label_desc',

  'financial_price_b2b_incl_vat_btpm_asc',
  'financial_price_b2b_incl_vat_btpm_desc',
  'outgoing_invoice_asc',
  'outgoing_invoice_desc',
  'action_ws2_interior_inspection_done_asc',
  'action_ws2_interior_inspection_done_desc',
  'b2b_price_asc',
  'b2b_price_desc',
  'brand_az',
  'brand_za',
  'status',
  'date_first_allowance',
];

if (env.clientId == AppClientId.HOOIKAMMER) {
  VEHICLES_SORT_OPTIONS.push('HOOI_stadagen_asc');
  VEHICLES_SORT_OPTIONS.push('HOOI_stadagen_desc');
}

/* eslint-disable react/prefer-stateless-function */
class VehicleSortSelectorComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  static getDerivedStateFromProps(props, state) {
    const { order, sortType } = props.filter;
    switch (sortType) {
      case 'createdAt':
        return { selected: 'createdAt' };
      case 'brand_name':
        if (order === 'asc') return { selected: 'brand_az' };
        if (order === 'desc') return { selected: 'brand_za' };
        break;
      case 'status':
        return { selected: 'status' };
      case 'outgoing_invoice':
        return { selected: 'outgoing_invoice' };
      case 'financial_price_b2b_incl_vat_btpm':
        return { selected: 'financial_price_b2b_incl_vat_btpm' };
      case 'task_label':
        return { selected: 'task_label' };
      case 'action_ws2_interior_inspection_done':
        return { selected: 'action_ws2_interior_inspection_done' };
      default:
        return null;
    }
  }

  handleChange = option => {
    console.log(this.state.selected);
    let sortType;
    let order = 'desc';
    this.setState({ selected: option?.value, currentSelectedValue: option?.value });
    switch (option.value) {
      case 'createdAt_asc': {
        sortType = 'createdAt';
        order = 'asc';
        break;
      }
      case 'createdAt_desc': {
        sortType = 'createdAt';
        order = 'desc';
        break;
      }
      case 'task_label_asc': {
        sortType = 'task_label';
        order = 'asc';
        break;
      }
      case 'task_label_desc': {
        sortType = 'task_label';
        order = 'desc';
        break;
      }
      case 'financial_price_b2b_incl_vat_btpm_asc': {
        // sortType = 'financial_price_b2b_incl_vat_btpm';
        sortType = 'b2b_price_change_date';
        order = 'asc';
        break;
      }
      case 'financial_price_b2b_incl_vat_btpm_desc': {
        // sortType = 'financial_price_b2b_incl_vat_btpm';
        sortType = 'b2b_price_change_date';
        order = 'desc';
        break;
      }
      case 'outgoing_invoice_asc': {
        sortType = 'outgoing_invoice';
        order = 'asc';
        break;
      }
      case 'outgoing_invoice_desc': {
        sortType = 'outgoing_invoice';
        order = 'desc';
        break;
      }
      case 'action_ws2_interior_inspection_done_asc': {
        sortType = 'action_ws2_interior_inspection_done';
        order = 'asc';
        break;
      }
      case 'action_ws2_interior_inspection_done_desc': {
        sortType = 'action_ws2_interior_inspection_done';
        order = 'desc';
        break;
      }
      case 'b2b_price_asc': {
        sortType = 'financial_price_b2b_incl_vat_btpm';
        order = 'asc';
        break;
      }
      case 'b2b_price_desc': {
        sortType = 'financial_price_b2b_incl_vat_btpm';
        order = 'desc';
        break;
      }
      case 'brand_az': {
        sortType = 'brand_name';
        order = 'asc';
        break;
      }
      case 'brand_za': {
        sortType = 'brand_name';
        break;
      }
      case 'status': {
        sortType = 'status';
        order = 'asc';
        break;
      }
      case 'date_first_allowance': {
        sortType = 'date_first_allowance';
        break;
      }
      case 'HOOI_stadagen_asc': {
        sortType = 'HOOI_stadagen';
        order = 'asc';
        break;
      }
      case 'HOOI_stadagen_desc': {
        sortType = 'HOOI_stadagen';
        order = 'desc';
        break;
      }
    }
    this.props.setSort(sortType, order);
  };

  get options() {
    return VEHICLES_SORT_OPTIONS?.map(o => {
      const lbl = `vehicle.sort.${o}`;
      return { label: `${this.lblStr(lbl)}`, value: o };
    });
  }

  render() {
    let { order, sortType } = this.props.filter;
    let selected = sortType === 'brand_name' ? (order === 'asc' ? 'brand_az' : 'brand_za') : sortType;
    let selectedLabel = this.options.find(opt => opt.value == this.state.currentSelectedValue)?.label;

    return (
      <div className={styles.container}>
        <Dropdown
          placeholder={this.lblStr(`vehicle.sort.by`)}
          options={this.options}
          value={selectedLabel}
          onChange={this.handleChange}
          className={styles.dropdown}
        />
      </div>
    );
  }
}

VehicleSortSelectorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectVehicleFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setSort(type, order) {
      dispatch(setVehiclesSort(type, order));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleSortSelector = compose(withConnect, withRouter, injectIntl)(VehicleSortSelectorComp);
